import {
  FILE_MODAL_CLOSE,
  FILE_MODAL_OPEN,
  FILES_SET,
  LOCATION_FETCH_FAIL,
  SET_TIP_DATA,
  TIP_DATA_RESET,
  TIP_MODAL_CLOSE,
  TIP_SUBMIT_SUCCESS
} from '@actions/types'

const initialState = {
  cardMediaFiles: [],
  category: '',
  configHash: '',
  currentFileUpload: null,
  expandedFile: null,
  fileUploads: [],
  isAwaitingLocation: false,
  isStandalone: false,
  isUploadingFile: false,
  message: '',
  sendAnonymously: false,
  sendLocation: false,
  showFilesModal: false,
  showTipSuccessModal: false,
  tipConfirmationText: '',
  type: 'tip',
  uploadProgress: 0
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
  case FILES_SET:
    return {
      ...state,
      ...payload
    }
  case FILE_MODAL_CLOSE:
    return {
      ...state,
      expandedFile: null,
      showFilesModal: false
    }
  case FILE_MODAL_OPEN:
    return {
      ...state,
      cardMediaFiles: payload.cardMediaFiles,
      expandedFile: payload.expandedFile,
      showFilesModal: true
    }
  case LOCATION_FETCH_FAIL:
    return {
      ...state,
      isAwaitingLocation: false
    }
  case SET_TIP_DATA:
    return {
      ...state,
      ...payload
    }
  case TIP_DATA_RESET:
    return {
      ...initialState,
      sendLocation: state.sendLocation,
      showTipSuccessModal: true
    }
  case TIP_MODAL_CLOSE:
    return {
      ...state,
      showTipSuccessModal: false,
      tipConfirmationText: ''
    }
  case TIP_SUBMIT_SUCCESS:
    return {
      ...state,
      isAwaitingLocation: false,
      showTipSuccessModal: true
    }
  default:
    return state
  }
}
export default reducer
